import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

/**
 * Scroll-triggered entrance wrapper used across the landing sections.
 * Falls back to a plain fade when the visitor prefers reduced motion.
 */
const Reveal = ({ children, delay = 0, y = 28, duration = 0.75, className = '', as = 'div' }) => {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: reduceMotion ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-90px' }}
      transition={{ duration: reduceMotion ? 0.3 : duration, delay, ease: EASE }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
